<template>
  <div class="d-flex align-center full-width touch">
    <v-btn icon @click="$router.push('/')" :color="color"><v-icon>mdi-home</v-icon></v-btn>
    <div v-if="lgAndUp" class="white--text">Home</div>
    <v-spacer></v-spacer>
    <div v-if="lgAndUp && permittedNavTabs.length > 1" class="pl-1 pr-3 caption white--text">Funktion auswählen</div>
    <v-btn-toggle v-model="view" mandatory rounded class="mr-auto">
      <template v-for="(navTab, ind) in permittedNavTabs">
        <v-btn :value="navTab.link" :key="ind"> {{ navTab.title }}</v-btn>
      </template>
    </v-btn-toggle>
    <header-date-picker class="mr-2" :color="color" />
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import HeaderDatePicker from './components/HeaderDatePicker.vue';
import { mapState } from 'vuex';
import index from './index.js';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
const navTabs = [
  { id: 'dispo', title: 'Dispo', link: '/worksheet/dispo' },
  // { id: 'zueri9ReadOnly', title: 'Lesezugriff auf Züri 9', link: '/worksheet/dispo-read-only' },
  { id: 'zueri9CustomerView', title: 'Kundenberater', link: '/worksheet/zueri9-customer-view' },
  { id: 'zueri9', title: 'Züri 9', link: '/worksheet/zueri9' },
  { id: 'admin', title: 'Administration', link: '/worksheet/admin' },
  { id: 'reporting', title: 'Reporting', link: '/worksheet/reporting' },
];
export default {
  name: 'VbzWorksheetHeader',
  mixins: [common, configMixin, wsMixin],
  components: {
    HeaderDatePicker,
  },
  mounted() {
    console.debug('moduleConfig', this.moduleConfig);
  },
  data() {
    return {
      view: this.$route.path || 'dispo',
    };
  },

  computed: {
    ...mapState('profile', ['user']),
    path() {
      return this.$route.path;
    },
    color() {
      return this.theme.appBar.other.color;
      // return `secondary ${this.darkMode ? 'lighten-1' : 'darken-2'}`;
    },
    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    viewsRestrictedToOneOfGroup() {
      return this.moduleConfig ? this.moduleConfig.viewsRestrictedToOneOfGroup : null;
    },
    navTabs() {
      return navTabs.map((navTab) => {
        return { ...navTab, restrictedTo: this.viewsRestrictedToOneOfGroup[navTab.id] };
      });
    },
    permittedNavTabs() {
      return this.navTabs.filter((navTab) => {
        return this.mx_isUserPermittedWhenRestrictedToGroups(navTab.restrictedTo);
      });
    },
    userGroups() {
      return this.user.groups.split(',');
    },
  },
  watch: {
    view(newValue, oldValue) {
      console.debug('view changed to', newValue);
      let path = newValue;
      if (path && path !== this.$route.path) {
        this.$router.push(path);
      }
    },
    path(newValue) {
      let permittedNavTab = this.permittedNavTabs.find((t) => t.link === newValue);
      if (permittedNavTab) {
        this.view = newValue;
      }
    },
  },
};
</script>
